// extracted by mini-css-extract-plugin
export default {"loginSuccessContainer":"bDEYFFokpq92wLktrrLF","emailSuccessIcon":"_I3IQMApTgcVVcbjrMrq","emailSuccessTitle":"Da53ti7ASj8Ffk6VSzWi","emailSuccessDetails":"FNLxM3xjNjNe__AE6xB_"};